import * as yup from "yup";
export const IGNORE_ERROR = "IGNORE";

export const FLEET_VEHICLE_OFFER_SALE_EDIT_FORM_SCHEMA = yup.object().shape({
  contactClientId: yup.string().required('Molimo Vas da odaberete kupca'),
  vehicleId: yup.string().required('Molimo Vas da odaberite vozilo'),
  offerDate: yup.string().required('Molimo Vas da unesite datum ponude'),
  dueDate: yup
    .string()
    .nullable()
    .when("durationDays", {
      is: (durationDays: string) => !durationDays,
      then: schema => schema.required("Unesite datum dospijeća ili broj dana"),
    }),

  // durationDays: yup
  //   .string()
  //   .nullable()
  //   .when("dueDate", {
  //     is: (dueDate: string) => !dueDate,
  //     then: schema => schema.required("Unesite datum dospijeća ili broj dana"),
  //   }),
  items: yup
    .array()
    .required("Stavke su obavezne")
    .test(
      "at-least-one-active-item",
      "Morate dodati barem jednu stavku u ponudu",
      items => Array.isArray(items) && items.some(item => !item?.deleted)
    ),
});







